import React from "react";
import img from "../assets/img/banner/img.svg";
import img2 from "../assets/img/banner/LeBron.png";
import img3 from "../assets/img/banner/img3.svg";
import img4 from "../assets/img/banner/Joker.png";
import img5 from "../assets/img/banner/img5.svg";
import img6 from "../assets/img/banner/Tatum.png";
import img7 from "../assets/img/banner/img7.svg";
import img8 from "../assets/img/banner/Steph.png";
import arrowDown from "../assets/img/banner/arrowRed.svg";
import arrowUp from "../assets/img/banner/arrowGreen.svg";

import Marquee from "react-fast-marquee";
const BannerSection = () => {
    // let videoRef = useRef(null);
    // let timer = null;
    // useEffect(() => {
    //     timer = setInterval(() => {
    //         if (videoRef.current) {
    //             videoRef.current.loop = true;
    //             videoRef.current.play();
    //             clearTimeout(timer);
    //         }
    //     }, 500);
    // }, [videoRef]);
    // const settings = {
    //     dots: false,
    //     arrows: false,
    //     infinite: true,
    //     slidesToShow: 12,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     speed: 2000,
    //     autoplaySpeed: 2000,
    //     cssEase: "linear",
    //     pauseOnHover: false,
    //     lazyLoad: "progressive",
    //     responsive: [
    //         {
    //             breakpoint: 2500,
    //             settings: {
    //                 slidesToShow: 10,
    //             },
    //         },
    //         {
    //             breakpoint: 2000,
    //             settings: {
    //                 slidesToShow: 8,
    //             },
    //         },
    //         {
    //             breakpoint: 992,
    //             settings: {
    //                 slidesToShow: 6,
    //             },
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 5,
    //             },
    //         },
    //         {
    //             breakpoint: 600,
    //             settings: {
    //                 slidesToShow: 3.5,
    //             },
    //         },
    //         {
    //             breakpoint: 400,
    //             settings: {
    //                 slidesToShow: 2.5,
    //             },
    //         },
    //     ],
    // };
    const data = [
        {
            avatar: img,
            status: "up",
            value: "5.71%",
        },
        {
            avatar: img2,
            status: "up",
            value: "4.23%",
            cat: "player",
        },
        {
            avatar: img3,
            status: "up",
            value: "9.75%",
        },
        {
            avatar: img4,
            status: "up",
            value: "6.03%",
            cat: "player",
        },
        {
            avatar: img5,
            status: "down",
            value: "2.77%",
        },
        {
            avatar: img6,
            status: "up",
            value: "1.93%",
            cat: "player",
        },
        {
            avatar: img7,
            status: "up",
            value: "1.82%",
        },
        {
            avatar: img8,
            status: "up",
            value: "2.65%",
            cat: "player",
        },
        {
            avatar: img,
            status: "up",
            value: "5.71%",
        },
        {
            avatar: img2,
            status: "up",
            value: "4.23%",
            cat: "player",
        },
        {
            avatar: img3,
            status: "up",
            value: "9.75%",
        },
        {
            avatar: img4,
            status: "up",
            value: "6.03%",
            cat: "player",
        },
        {
            avatar: img5,
            status: "down",
            value: "2.77%",
        },
        {
            avatar: img6,
            status: "up",
            value: "1.93%",
            cat: "player",
        },
        {
            avatar: img7,
            status: "up",
            value: "1.82%",
        },
        {
            avatar: img8,
            status: "up",
            value: "2.65%",
            cat: "player",
        },
    ];

    return (
        <div className="mt-auto">
            {/* <video
                ref={videoRef}
                preload="auto"
                autoPlay
                loop
                className="w-full object-cover hidden md:block"
            >
                <source src={Banner} type="video/mp4" />
                <source src={BannerWebp} type="video/mp4" />
            </video>
            <img
                src={BannerMobile}
                className="w-full object-cover block md:hidden"
            /> */}
            {/* <Slider {...settings} className="bg-black text-white w-100">
                {data.map((item, idx) => {
                    return (
                        <>
                            <div
                                className="flex items-center justify-center my-2"
                                key={idx}
                            >
                                <img src={item.avatar} width={50} />
                                {item.status == "up" ? (
                                    <img
                                        src={arrowUp}
                                        width={15}
                                        className="mx-1"
                                    />
                                ) : (
                                    <img
                                        src={arrowDown}
                                        width={15}
                                        className="mx-1"
                                    />
                                )}

                                <span className="font-semibold">
                                    {item.value}
                                </span>
                            </div>
                        </>
                    );
                })}
            </Slider> */}

            <Marquee
                className="bg-black text-white flex items-center justify-center "
                speed={100}
            >
                {data.map((item, idx) => {
                    return (
                        <>
                            <div
                                className="flex items-center justify-center my-2 mx-5"
                                key={idx}
                            >
                                <img src={item.avatar} alt="" width={50} />
                                {item.status === "up" ? (
                                    <img
                                        src={arrowUp}
                                        alt=""
                                        width={15}
                                        className={`mx-1  `}
                                    />
                                ) : (
                                    <img
                                        src={arrowDown}
                                        alt=""
                                        width={15}
                                        className={`mx-1 `}
                                    />
                                )}

                                <span className="font-semibold">
                                    {item.value}
                                </span>
                            </div>
                        </>
                    );
                })}
            </Marquee>
        </div>
    );
};

export default BannerSection;
